import { useEffect, useState } from "react";

import axios from "axios";

function useIpLocation() {
  const [ipLocation, setIpLocation] = useState(null);
  const [ipInfoLocation, setIpInfoLocation] = useState(null);

  useEffect(() => {
    if (!navigator.geolocation) {
      console.warn("Geolocation not supported or request not accepted");
      return;
    }
    setIpLocation(navigator.geolocation);
  }, []);

  const getIpLocation = async () => {
    try {
      const res = await axios.get(
        "https://ipinfo.io/json?token=5a44beeea210d6"
      );
      let data = res?.data;
      if (data && typeof data === "object") {
        setIpInfoLocation(data);
      }
    } catch (e) {
      console.warn("failed to get ip location using ipinfo key");
    }
  };

  useEffect(() => {
    getIpLocation();
  }, []);

  return { ipLocation, ipInfoLocation };
}

export default useIpLocation;
